export default {
    env: process.env.NODE_ENV,
    apiBaseUrl: process.env.API_BASE_URL,
    baseUrl: process.env.BASEURL,
    adminPath: 'app',
    lang: 'th'
};

export const RESERVATIONS_ENABLED = false;

export const PerPage = () => {
    return [5, 10, 25, 50, 100];
};

export const timeZonelist = () => {
    return {
        "value": "SE Asia Standard Time",
        "abbr": "SAST",
        "offset": 7,
        "isdst": false,
        "text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        "timezone": "Asia/Bangkok"
    };
};

export const formatDateTime = () => {
    return 'DD/MM/YYYY HH:mm';
};

export const dateFormatMoment = () => {
    return 'DD/MM/YYYY';
}

export const showTextPicker = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).utc().format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).utc().format(dateFormatMoment());
    } else {
        return 'Select Date';
    }
}
